import { render, staticRenderFns } from "./ColumnSize.vue?vue&type=template&id=253b7188&scoped=true"
import script from "./ColumnSize.vue?vue&type=script&lang=js"
export * from "./ColumnSize.vue?vue&type=script&lang=js"
import style0 from "./ColumnSize.vue?vue&type=style&index=0&id=253b7188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253b7188",
  null
  
)

export default component.exports